import React, {useEffect, useCallback} from 'react';
import {useSelector} from "react-redux";

export function TextareaChat({inputRef, loading, placeholder, minHeight = 68, handleFocus = null, handleSubmit, handleChange}) {
  const sendBy = useSelector(state => state.chat.settings ? state.chat.settings.send_by || 0 : 0);

  const onKeyDown = useCallback((e) => {
    if ((sendBy === 0 && e.keyCode === 13 && e.ctrlKey) || (sendBy === 1 && e.keyCode === 13 && !e.ctrlKey)) {
      e.preventDefault();
      handleSubmit();
    }
  }, [sendBy, handleSubmit]);

  const autoHeight = useCallback(() => {
    inputRef.current.style.height = 'auto';
    inputRef.current.style.height = Math.min(Math.max(minHeight, inputRef.current.scrollHeight) + 2, 427) + 'px';
  }, [minHeight, inputRef]);

  useEffect(() => {
    const input = inputRef.current;
    if (!input) {
      return;
    }
    input.addEventListener('keydown', onKeyDown);
    input.addEventListener('input', autoHeight);

    return () => {
      input.removeEventListener('keydown', onKeyDown);
      input.removeEventListener('input', autoHeight);
    }
  }, [onKeyDown, autoHeight, inputRef]);

  return <textarea ref={inputRef} maxLength={4096} className="chat-panel__text" placeholder={placeholder} disabled={loading} onFocus={handleFocus} onChange={handleChange} id="add_message"></textarea>;
}
